export const SET_MATA_DATA = 'SET_MATA_DATA';
export const SET_PAGENAME = 'SET_PAGENAME';

//schedule
export const GET_SCHEDULE_BEGIN = 'GET_SCHEDULE_BEGIN';
export const GET_SCHEDULE_FAILED = 'GET_SCHEDULE_FAILED';
export const GET_SCHEDULE = 'GET_SCHEDULE';
export const CHANGE_FILTERS = 'CHANGE_FILTERS';
//channel
export const GET_CHANNELS = 'GET_CHANNELS';
export const GET_CHANNELS_LIVE_STATS = 'GET_CHANNELS_LIVE_STATS';

//game
export const GET_GAME = 'GET_GAME';
export const GET_CHANNEL = 'GET_CHANNEL';

//home
export const GET_HOME_SITE_NAV = 'GET_HOME_SITE_NAV';
export const GET_HOME_SITE_NAV_BEGIN = 'GET_HOME_SITE_NAV_BEGIN';
export const GET_HOME_SITE_NAV_ITEM = 'GET_HOME_SITE_NAV_ITEM';
export const RESET_HOME = 'RESET_HOME';